import { Component, Input, OnInit } from '@angular/core';
import { UiOnParamsChanged } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ScriptingToolService } from 'src/app/components/scripting-tool/services/scripting-tool.service';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { Subdomain } from 'src/app/model/enum/observations/subdomain.enum';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { FormalNoteDTO } from 'src/app/model/observation/formal/formal-note-dto.model';
import { FormalModel } from 'src/app/model/observation/formal/formal.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { ObservationLookUpTypes } from 'src/app/observations/helpers/observation-lookup-types/observation-lookup-types.helper';
import { ResourceData } from 'src/app/services/resource/resource.service';

export const SCRIPTING_TOOL_TAB = 0;
export const ASSIGN_EVIDENCE_TAB = 1;
export const EDIT_EVIDENCE_TAB = 2;

@Component({
    selector: 'app-formal-evidence-base',
    templateUrl: './formal-evidence-base.component.html',
    styleUrls: ['./formal-evidence-base.component.scss'],
    providers: [ScriptingToolService]
})
export class FormalEvidenceBaseComponent implements OnInit, UiOnParamsChanged {
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() formalDetails?: FormalModel;
    @Input() initialEvidence: FormalNoteDTO[] = [];
    @Input() resourceFile: ResourceData = {};

    public tabIndex: number = 0;
    public filterType?: DomainFilterType;
    public currentSubdomain?: Subdomain;
    
    public subdomains: SubdomainLookup[] = []
    public evidence: string = '';

    SCRIPTING_TOOL_TAB = SCRIPTING_TOOL_TAB;
    ASSIGN_EVIDENCE_TAB = ASSIGN_EVIDENCE_TAB;
    EDIT_EVIDENCE_TAB = EDIT_EVIDENCE_TAB;

    constructor(
        private scrpitingToolService: ScriptingToolService,
        private stateService: StateService,
        private transition: Transition
    ) { }

    ngOnInit(): void {
        this.setParams(this.transition);
        this.subdomains = ObservationLookUpTypes.generateAllComponents(this.resourceFile);
        this.scrpitingToolService.initialize(this.initialEvidence);
    }

    uiOnParamsChanged(newParams: { [paramName: string]: any; }, trans?: Transition | undefined): void {
        this.setParams(trans);
    }

    navigateTab(tabIndex: number) {
        this.stateService.go('.', { tabIndex, filterType: DomainFilterType.ALL, currentSubdomain: Subdomain.CONTENT_KNOWLEDGE });
    }

    private setParams(transition?: Transition | undefined) {
        if (transition?.success) {
            const { tabIndex, filterType, currentSubdomain } = transition.params();

            this.tabIndex = tabIndex;
            this.filterType = filterType;
            this.currentSubdomain = currentSubdomain;
        }
    }
}
